/**
 * Thrown by {@link ScribeApiClient} whenever the server returns a non-2xx response.
 * Carries the parsed error envelope (when the body was valid JSON matching the
 * `Error` schema) alongside the raw HTTP status for callers that want to branch on it.
 */
export class ScribeApiError extends Error {
    name = "ScribeApiError";
    status;
    code;
    details;
    requestId;
    body;
    /** `headerRequestId` (the response's `X-Request-Id`) is the fallback when the body carries
     * no `error.request_id` — e.g. a 5xx from the gateway with a non-JSON body. */
    constructor(status, body, headerRequestId) {
        const parsed = isApiErrorBody(body) ? body.error : undefined;
        super(parsed?.message ?? `Request failed with status ${status}`);
        this.status = status;
        this.code = parsed?.code;
        this.details = parsed?.details;
        this.requestId = parsed?.request_id ?? headerRequestId;
        this.body = body;
    }
}
function isApiErrorBody(body) {
    if (typeof body !== "object" || body === null)
        return false;
    const err = body.error;
    if (typeof err !== "object" || err === null)
        return false;
    const e = err;
    return typeof e.code === "string" && typeof e.message === "string";
}
/** A transport-level failure (network error, timeout, abort) — never reached the server. */
export class ScribeNetworkError extends Error {
    name = "ScribeNetworkError";
    cause;
    constructor(message, cause) {
        super(message);
        this.cause = cause;
    }
}
//# sourceMappingURL=errors.js.map